import { Injectable } from '@angular/core';
import { HttpService } from './utils/http.service';
import { IHomeAppointmentsSummaryModel, IHomeQuotesSummaryModel } from '@models';

@Injectable()
export class DashboardService {
	constructor(private readonly httpService: HttpService) { }

	async getLeadsSummary(period: 'YTD' | 'MTD' = 'YTD'): Promise<IHomeQuotesSummaryModel> {
		return this.httpService.get('/dashboard/getLeadsSummary', { period });
	}

	async getQuotesSummary(period: 'YTD' | 'MTD' = 'YTD', filteredLocationIds?: number[]): Promise<IHomeQuotesSummaryModel> {
		const params: any = { period };

		if (filteredLocationIds?.length)
			params.filteredLocationIds = JSON.stringify(filteredLocationIds);

		return this.httpService.get('/dashboard/getQuotesSummary', params);
	}

	async getInvoicesSummary(period: 'YTD' | 'MTD' = 'YTD', invoiceStatusId: number = 5, filteredLocationIds?: number[]): Promise<IHomeQuotesSummaryModel> {
		const params: any = { period, invoiceStatusId };

		if (filteredLocationIds?.length)
			params.filteredLocationIds = JSON.stringify(filteredLocationIds);

		return this.httpService.get('/dashboard/getInvoicesSummary', params);
	}

	async getPaymentsSummary(period: 'YTD' | 'MTD' = 'YTD', showUnappliedOnly: boolean = false, showArchived: boolean = false): Promise<IHomeQuotesSummaryModel> {
		return this.httpService.get('/dashboard/getPaymentsSummary', { period, showUnappliedOnly, showArchived });
	}

	async getOverdueInvoicesSummary(period: 'YTD' | 'MTD' = 'YTD', filteredLocationIds?: number[]): Promise<IHomeQuotesSummaryModel> {
		const params: any = { period };

		if (filteredLocationIds?.length)
			params.filteredLocationIds = JSON.stringify(filteredLocationIds);

		return this.httpService.get('/dashboard/getOverdueInvoicesSummary', params);
	}

	async getTodaysAppointmentsSummary(filteredLocationIds?: number[], date?: string): Promise<IHomeAppointmentsSummaryModel> {
		const params: any = {};

		if (filteredLocationIds !== undefined)
			params.filteredLocationIds = JSON.stringify(filteredLocationIds ?? []);

		if (date)
			params.date = date;

		return this.httpService.get('/dashboard/getTodaysAppointmentsSummary', params);
	}
}
